import {type IAsset} from '@netx/core-asset-next/schema';

export const assetIsInCart = (asset?: IAsset) => asset?.inCurrentCart === true;

export default assetIsInCart;
